import type { CSSProperties } from 'react';

import type { CustomAttribute, DreamRenderElementProps, EmptyChildren } from '../types';

export enum QuestionTypes {
  FREE_FORM = 'free_form',
  MULTIPLE_CHOICE = 'multiple_choice',
  DROPDOWN = 'dropdown',
  LONG_TEXT = 'long_text',
}

export type SurveyQuestionTypes =
  | QuestionTypes.FREE_FORM
  | QuestionTypes.MULTIPLE_CHOICE
  | QuestionTypes.DROPDOWN
  | QuestionTypes.LONG_TEXT;

export enum SurveyStatus {
  DRAFT = 'draft',
  LIVE = 'live',
  ARCHIVED = 'archived',
}
export type SurveyStatusTypes = SurveyStatus.DRAFT | SurveyStatus.LIVE | SurveyStatus.ARCHIVED;

export interface CustomField {
  id: string;
  kind: string;
}

export interface QuestionOption {
  id: string;
  value: string;
}

export interface Question {
  id: string;
  order: number;
  prompt: string;
  question_type: SurveyQuestionTypes;
  required: boolean;
  multi_select: boolean;
  max_character_limit: number;
  min_character_limit: number;
  show_max_characters: boolean;
  custom_field: CustomField;
  form_question_options: QuestionOption[];
}

export interface Survey {
  id: string;
  title: string;
  description: string;
  cta_text: string;
  thank_you_message: string;
  status: Question;
  form_questions: Question[];
}

export type TSurveyElement = {
  type: 'survey';
  content: EmptyChildren;
  attrs: {
    answerTextColor?: CSSProperties['color'];
    answerTextFontFamily?: CSSProperties['fontFamily'];
    answerBackgroundColor?: CSSProperties['backgroundColor'];
    id: string;
    height?: number;
    width?: number;
    mobile_hide?: boolean;
    desktop_hide?: boolean;
    customAttributes?: CustomAttribute;
    gap?: CSSProperties['gap'];
    padding?: CSSProperties['padding'];
    shadow?: CSSProperties['boxShadow'];
    textAlign?: CSSProperties['textAlign'];
    borderRadius?: CSSProperties['borderRadius'];
    borderWidth?: CSSProperties['borderWidth'];
    borderColor?: CSSProperties['borderColor'];
    borderStyle?: CSSProperties['borderStyle'];
    inputBorderRadius?: CSSProperties['borderRadius'];
    inputBorderWidth?: CSSProperties['borderWidth'];
    inputBorderColor?: CSSProperties['borderColor'];
    inputBorderStyle?: CSSProperties['borderStyle'];
    background?: CSSProperties['backgroundColor'];
    helperTextColor?: CSSProperties['color'];
    helperTextFontFamily?: CSSProperties['fontFamily'];
    labelColor?: CSSProperties['color'];
    labelFontFamily?: CSSProperties['fontFamily'];
    titleColor?: CSSProperties['color'];
    titleFontFamily?: CSSProperties['fontFamily'];
    titleFontSize?: CSSProperties['fontSize'];
    descriptionColor?: CSSProperties['color'];
    descriptionFontFamily?: CSSProperties['fontFamily'];
    descriptionFontSize?: CSSProperties['fontSize'];
    mobilePadding?: CSSProperties['padding'];
    buttonColor?: CSSProperties['color'];
    buttonTextColor?: CSSProperties['color'];
    buttonTextFontFamily?: CSSProperties['fontFamily'];
    inputBackgroundColor?: CSSProperties['backgroundColor'];
    inputTextColor?: CSSProperties['color'];
    inputTextFontFamily?: CSSProperties['fontFamily'];
    inputPlaceholderColor?: CSSProperties['color'];
    requiredColor?: CSSProperties['color'];
    data: any;
  };
};

export type SurveyElementProps = DreamRenderElementProps<TSurveyElement>;
